import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage } from 'firebase/messaging';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { writeLog } from './services/log.service'

const firebaseConfig = {
    apiKey: "AIzaSyAamn373-LtnBJ4EeuAX4YFtoi5OVaxQGA",
    authDomain: "tcsnz-6bd9e.firebaseapp.com",
    projectId: "tcsnz-6bd9e",
    storageBucket: "tcsnz-6bd9e.firebasestorage.app",
    messagingSenderId: "807175910412",
    appId: "1:807175910412:web:376301b2cf56d909daea29"
};

// console.log('*** Environment ***', process.env.REACT_APP_ENV)
// console.log('*** Firebase Config ***', firebaseConfig)

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);


export const getOrRegisterServiceWorker = () => {
    if ('serviceWorker' in navigator) {
        return window.navigator.serviceWorker
            .getRegistration('/firebase-push-notification-scope')
            .then(async (serviceWorker) => {
                if (serviceWorker) {
                    await serviceWorkerRegistration.unregister()
                    return serviceWorker;
                }
                return window.navigator.serviceWorker.register('./firebase-messaging-sw.js', {
                    scope: '/firebase-push-notification-scope',
                });
            });
    }
    throw new Error('The browser doesn`t support service worker.');
};

export const getFirebaseToken = () =>
    getOrRegisterServiceWorker()
        .then((serviceWorkerRegistration) =>
            getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY, serviceWorkerRegistration }));

export const onForegroundMessage = () =>
    new Promise((resolve) => onMessage(messaging, (payload) => {
        // console.log('messaging', messaging)
        console.log('payload', payload)
        const notificationTitle = payload.notification.title;
        const notificationOptions = { body: payload.notification.body };
        if (Notification.permission === 'granted') {
			console.log('you are on 1.3.6');

			 getOrRegisterServiceWorker()
        		.then((serviceWorkerRegistration) =>
            	serviceWorkerRegistration.showNotification(notificationTitle, notificationOptions));
            //new Notification(notificationTitle, notificationOptions);
			//messaging.showNotification(notificationTitle, notificationOptions);
			console.log('Notification shown:', notificationTitle, notificationOptions);
        } else {
            console.log('Notification permission not granted, cannot show foreground notification.');
        }
        resolve(payload)
    }));

export const subscribeToTopic = async (hmis) => {
	console.log('subscribeToTopic', hmis);
    const developerMode = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    const getHmisUri = developerMode ? process.env.REACT_APP_DC_DEVELOP : process.env.REACT_APP_DC_PRODUCTION
    const protocol = (process.env.REACT_APP_USE_SSL === 'false') ? 'http' : 'https'

    //const installation_id = hmis[0].installationID;
    const registrationToken = JSON.parse(localStorage.getItem('registrationToken'));
    const token = registrationToken.token;
    const authToken = JSON.parse(localStorage.getItem('access_token')).idToken;
     
    if (!authToken || !authToken) {
		console.log('Unauthorized: access tokens are missing or invalid');
        writeLog('Error', `Unauthorized: access tokens are missing or invalid`)
        return
    }

	for (let i = 0; i < hmis.length; i++) {
		const installation_id = hmis[i].installationID;
		console.log('Subscribe to Installation', installation_id);

		await fetch(`${protocol}://${getHmisUri}/SubscribeRole/${installation_id}/${token}`, {
			method: "PUT",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authToken}`
			},
			body: JSON.stringify({
				installation_id: installation_id,
				token: token,
			}),
		});
	}
}

